import { gql } from '@apollo/client'

export default gql`
  fragment AllowedMonetaryTargets on Meeting {
    allowedMonetaryTargets {
      newTargetsAllowed
      pastTargetsAllowed
    }
  }
`
